import Router from './Routes/Router';

function App() {
  return (
    <>
      <Router />;
    </>
  );
}

export default App;
